import {
  PRICING_SELECT_LANGUAGE,
  PRICING_CLEAR_DATA,
  PRICING_DATA_FETCH,
  PRICING_DATA_SUCCESS,
  PRICING_DATA_FAILURE
} from './actionTypes';

const initialState = {
  isLoaded: false,
  lang: '',
  data: [],
  error: []
};

export const pricingReducer = (state = initialState, action) => {
  switch (action.type) {
    case PRICING_SELECT_LANGUAGE:
      return { ...state, lang: action.payload };
    case PRICING_CLEAR_DATA:
      return initialState;
    case PRICING_DATA_FETCH:
      return { ...state, isLoaded: false };
    case PRICING_DATA_SUCCESS:
      return { ...state, isLoaded: true, data: action.payload.data };
    case PRICING_DATA_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/Pricing/reducer.js